import BiometricAttendanceLogsContainer from "../../container/admin/biometric-attendance-logs/BiometricAttendanceLogsContainer";

const BiometricAttendanceLogs = () => {
    return <BiometricAttendanceLogsContainer />;
};

export default BiometricAttendanceLogs;
